import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import allArtists from '../data/artistsData';
import mandala from '../assets/wallpaper.png';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; 
import ScrollToHashElement from '../pages/ScrollToHashElement'; // 👈 Import here
import { useNavigate } from 'react-router-dom';


const FeaturedArtist = () => {
  const tabs = ['Dancers', 'Musicians', 'Singers', 'Theatre'];
  const [selectedTab, setSelectedTab] = useState('Dancers');
  const [startIndex, setStartIndex] = useState(0);

 
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);
const navigate = useNavigate();
const tabToPathMap = {
  Dancers: '/artist-dancers',
  Musicians: '/artist-musicians',
  Singers: '/artist-singers',
  Theatre: '/artist-theatre',
};



useEffect(() => {
  const handleResize = () => {
    setIsLargeScreen(window.innerWidth >= 768);
  };
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);





  const artists = (allArtists[selectedTab] || []).slice(0, 12);
  
  // Always show 3 artists but control visibility with CSS
  // const visibleArtists = artists.slice(startIndex, startIndex + 3);
  const visibleCount = isLargeScreen ? 3 : 1;
const visibleArtists = artists.slice(startIndex, startIndex + visibleCount);


const handlePrev = () => {
  const step = isLargeScreen ? 3 : 1;
  setStartIndex(prev => Math.max(0, prev - step));
};

const handleNext = () => {
  const step = isLargeScreen ? 3 : 1;
  const remaining = artists.length - startIndex - step;
  if (remaining >= 0) {
    setStartIndex(prev => prev + step);
  } else if (startIndex < artists.length - 1) {
    // Show remaining artists (less than step)
    setStartIndex(prev => prev + (artists.length - startIndex));
  }
};


  const handleTabChange = (label) => {
    setSelectedTab(label);
    setStartIndex(0);
  };

  return (
    <div
      id="artists"
      className="w-full font-[Poppins] relative overflow-hidden bg-white"
    >
      <ScrollToHashElement />
      {/* Mandala background - hidden on mobile */}
      <div className="hidden md:block">
        <img
          src={mandala}
          alt="mandala"
          className="absolute top-[-300px] left-[-270px] w-[600px] opacity-[0.7] z-0"
        />
        <img
          src={mandala}
          alt="mandala"
          className="absolute top-[-300px] right-[-270px] w-[600px] opacity-[0.7] z-0"
        />
        <img
          src={mandala}
          alt="mandala"
          className="absolute bottom-[-200px] left-[-220px] w-[500px] opacity-[0.7] z-0"
        />
        <img
          src={mandala}
          alt="mandala"
          className="absolute bottom-[-200px] right-[-220px] w-[500px] opacity-[0.7] z-0"
        />
      </div>

      <h2 className="text-center text-[#AD2F3B] underline decoration-[#AD2F3B] decoration-2 font-bold underline-offset-8 text-4xl  text-[20px] md:text-4xl  md:mt-[50px]">
        ARTIST SHOWCASE
      </h2>

      <div className="flex justify-center">
        <p className="text-center text-gray-700 font-[Poppins] text-[16px] md:text-[22px] mt-[20px] md:mt-[50px] w-[90%] md:w-[900px]">
          Meet India's talented traditional performing artists - from
          classical, folk & fusion, singers, dancers, musicians & theatre artists -
          all on one platform.
        </p>
      </div>

      {/* Tabs */}
      <div className="flex justify-center mt-[40px] md:mt-[80px]">
        <div className="flex items-center justify-between px-2 py-1 rounded-full border-[2px] border-[#AD2F3B] bg-[#AD2F3B] w-[95%] md:w-[950px] h-[45px] md:h-[65px]">
          {tabs.map((label, index) => (
            <button
              key={label}
              className={`flex-1 h-full transition-all duration-300 rounded-full capitalize ${
                selectedTab === label
                  ? "bg-white text-[#AD2F3B] text-[14px] md:text-[24px]"
                  : "bg-[#AD2F3B] text-white hover:!text-[#AD2F3B] hover:bg-white text-[12px] md:text-[20px]"
              } ${index !== 0 ? "ml-2" : ""}`}
              onClick={() => handleTabChange(label)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Artists with navigation */}
<div className="flex justify-center mt-[40px] md:mt-[105px]">
  <div className="relative flex items-center justify-center w-full">
    {/* Left Arrow - Adjusted for vertical centering */}
    <button
  onClick={handlePrev}
  disabled={startIndex === 0}
  className={`text-black font-normal absolute z-10 left-3 md:left-20 text-[30px] md:text-[70px] transition-opacity duration-200 ${
    startIndex === 0
      ? "opacity-0 cursor-not-allowed"
      : "opacity-100 cursor-pointer"
  }`}
  style={{
    top: "calc(50% - 20px)",
    transform: "translateY(-50%)"
  }}
>
  {"<"}
</button>


    {/* Artist Container */}
    <div className="flex justify-center items-center gap-10 overflow-hidden w-[300px] md:w-[1290px] min-w-[300px]">
      {visibleArtists.map((artist, index) => (
        <div
          key={index}
          className={`transition-all duration-300 ${
            index === 0 ? "block" : "hidden md:block"
          }`}
        >
          <Link
  to={`/artist/${artist.name.replace(/\s+/g, "-").toLowerCase()}`}
  state={{
    artist,
    artistList: artists, // full list of 12 artists from selected tab
    // referrer: `artist-${selectedTab.toLowerCase()}`
  }}
  className="flex flex-col items-center"
>

            <img
              src={artist.image}
              alt={artist.name}
              className="object-cover w-[300px] h-[300px] md:w-[400px] md:h-[400px]"
            />
            <p className="text-black mt-4 underline decoration-white text-[18px] md:text-[28px]">
              {artist.name}
            </p>
            <p className="text-gray-600 text-[14px] md:text-[18px] underline decoration-white italic capitalize">
              {artist.form}
            </p>
          </Link>
        </div>
      ))}
    </div>

    {/* Right Arrow - Adjusted for vertical centering */}
<button
  onClick={handleNext}
  disabled={startIndex + visibleCount >= artists.length}
  className={`text-black font-normal absolute z-10 right-3 md:right-20 text-[30px] md:text-[70px] transition-opacity duration-200 ${
    startIndex + visibleCount >= artists.length
      ? "opacity-0 cursor-not-allowed"
      : "opacity-100 cursor-pointer"
  }`}
  style={{
    top: "calc(50% - 20px)",
    transform: "translateY(-50%)"
  }}
>
  {">"}
</button>

  </div>
</div>
            {/* View More Button */}
{/* View More Button */}
<div className="flex justify-center md:mt-16 mt-4 md:mb-2">
  <button
    onClick={() => navigate(tabToPathMap[selectedTab])}
    className="bg-[#AD2F3B] text-white px-8 py-2 md:px-10 md:py-3 rounded-full text-[14px] md:text-[20px] font-medium shadow-none hover:shadow-[0_8px_15px_rgba(173,47,59,0.3)] transition-shadow duration-300"
  >
    View More
  </button>
</div>


    </div>
  );
};

export default FeaturedArtist;